import React, { Component, FormEvent, createRef, RefObject } from 'react'
import Button from 'tfs.button'
import RadioInput from 'tfs.form-radio-input'
import NumberInput from 'tfs.form-number-input'

import SSRInterface from '../../interfaces/client/SSR'

import getLabels from '../../utils/getLabels'

import styles from './AdditionalNotesForm.module.scss'

interface AdditionalNotesFormPropsInterface {
  passengerId: string
  ssr: SSRInterface
  showLeaveAtGateOption: boolean
  title: string
  cancelHandler: Function
  submitHandler: Function
  passengerName?: string
}

export default class AdditionalNotesForm extends Component<
  AdditionalNotesFormPropsInterface
> {
  _formRef: RefObject<HTMLFormElement> = createRef()
  _heightInputRef: RefObject<HTMLInputElement> = createRef()
  _widthInputRef: RefObject<HTMLInputElement> = createRef()
  _lengthInputRef: RefObject<HTMLInputElement> = createRef()
  _weightInputRef: RefObject<HTMLInputElement> = createRef()
  _leaveAtCheckInInputRef: RefObject<HTMLInputElement> = createRef()
  _leaveAtGateInInputRef: RefObject<HTMLInputElement> = createRef()

  private readonly _submitHandler = (event: FormEvent) => {
    event.preventDefault()

    if (this._formRef.current && this._formRef.current.checkValidity()) {
      this.props.submitHandler(
        this._formRef.current.elements,
        this.props.passengerId,
        this.props.ssr.id
      )
    }
  }

  render() {
    const {
      passengerName,
      ssr,
      showLeaveAtGateOption,
      cancelHandler,
      title,
    } = this.props

    return (
      <form
        className={styles['wrapper']}
        onSubmit={this._submitHandler}
        ref={this._formRef}
      >
        {passengerName && (
          <div className={styles['wrapper-inner']}>
            <p
              className={styles['passenger-name']}
              data-element="passenger-name"
            >
              {passengerName}
            </p>
          </div>
        )}

        <div className={`${styles['wrapper-inner']} ${styles['fields']}`}>
          <legend className={styles['title']}>{title}</legend>

          <fieldset className={styles['fieldset']}>
            <div className={styles['dimensions']}>
              <NumberInput
                name="height"
                data-element="additional-notes-form-height"
                label={getLabels('height')}
                required={true}
                elementRef={this._heightInputRef}
                autoFocus={true}
              />
              <NumberInput
                name="width"
                data-element="additional-notes-form-width"
                label={getLabels('width')}
                required={true}
                elementRef={this._widthInputRef}
              />
              <NumberInput
                name="length"
                data-element="additional-notes-form-length"
                label={getLabels('length')}
                required={true}
                elementRef={this._lengthInputRef}
              />
              <NumberInput
                name="weight"
                data-element="additional-notes-form-weight"
                label={getLabels('weight')}
                required={true}
                elementRef={this._weightInputRef}
              />
            </div>
          </fieldset>

          {showLeaveAtGateOption && (
            <fieldset
              className={`${styles['fieldset']} ${styles['leave-option']}`}
            >
              <p>{`${ssr.name} ${getLabels('check_in_or_gate')}`}</p>

              <RadioInput
                id="check-in"
                value="check-in"
                name="leaveSSRAt"
                required={true}
                label={getLabels('leave_at_check_in')}
                elementRef={this._leaveAtCheckInInputRef}
              />
              <RadioInput
                id="gate"
                value="gate"
                name="leaveSSRAt"
                required={true}
                label={getLabels('leave_at_gate')}
                elementRef={this._leaveAtGateInInputRef}
              />
            </fieldset>
          )}
        </div>

        <div className={`${styles['wrapper-inner']} ${styles['actions']}`}>
          <Button type="submit" data-element="confirm-add-special-ssr">
            {getLabels('add_special_ssr')}
          </Button>

          <Button
            type="button"
            color="white"
            onClick={cancelHandler}
            data-element="cancel"
          >
            {getLabels('cancel')}
          </Button>
        </div>
      </form>
    )
  }
}
